import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "d-flex flex-column align-items-start w-100" }
const _hoisted_2 = { class: "d-flex flex-column align-items-start w-100" }
const _hoisted_3 = { class: "flex justify-center mt-3 gap-x-1" }
const _hoisted_4 = { class: "d-flex align-items-center gap-2 flex-wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LabelCustom = _resolveComponent("LabelCustom")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_DivCol = _resolveComponent("DivCol")!
  const _component_DivRow = _resolveComponent("DivRow")!
  const _component_ButtonCustom = _resolveComponent("ButtonCustom")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_PageContentSection = _resolveComponent("PageContentSection")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_CaiDatCreateModal = _resolveComponent("CaiDatCreateModal")!
  const _component_CaiDatEditModal = _resolveComponent("CaiDatEditModal")!
  const _component_PageContentBase = _resolveComponent("PageContentBase")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_PageContentBase, { plain: "" }, {
    default: _withCtx(() => [
      _createVNode(_component_PageContentSection, { "always-expanded": true }, {
        header: _withCtx(() => [
          _createTextVNode("Cấu hình hệ thống")
        ]),
        default: _withCtx(() => [
          _createVNode(_component_el_form, {
            ref: "formRef",
            model: _ctx.form,
            onSubmit: _withModifiers(_ctx.onSubmit, ["prevent"])
          }, {
            default: _withCtx(() => [
              _createVNode(_component_DivRow, { class: "mb-3 g-3" }, {
                default: _withCtx(() => [
                  _createVNode(_component_DivCol, {
                    "additional-class": "pb-4",
                    cols: 6
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_1, [
                        _createVNode(_component_LabelCustom, { "is-text-muted": false }, {
                          default: _withCtx(() => [
                            _createTextVNode("Năm làm việc")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, { class: "mb-0 w-full" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              modelValue: _ctx.form.year,
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.year) = $event)),
                              class: "w-full",
                              placeholder: "Chọn năm làm việc"
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.workingYears, (year) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: year,
                                    label: String(year),
                                    value: String(year)
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_DivCol, {
                    "additional-class": "pb-4",
                    cols: 6
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_2, [
                        _createVNode(_component_LabelCustom, { "is-text-muted": false }, {
                          default: _withCtx(() => [
                            _createTextVNode("Đơn vị")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, { class: "mb-0 w-full" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              modelValue: _ctx.form.idDonVi,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.idDonVi) = $event)),
                              class: "w-full",
                              clearable: "",
                              filterable: "",
                              placeholder: "Chọn đơn vị",
                              disabled: !_ctx.isCompanyLevel
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.departmentOptions, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item.id,
                                    label: item.ten_don_vi,
                                    value: item.id
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue", "disabled"])
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_ButtonCustom, {
                  classes: `rounded-none m-0`,
                  "button-type": _ctx.ButtonsType.SAVE,
                  "color-type": _ctx.ButtonTypeColors.SUCCESS,
                  "is-loading": _ctx.isSaving,
                  disabled: _ctx.isSaving,
                  onClick: _ctx.onSubmit
                }, {
                  "button-label": _withCtx(() => [
                    _createTextVNode("Thay đổi")
                  ]),
                  _: 1
                }, 8, ["button-type", "color-type", "is-loading", "disabled", "onClick"])
              ])
            ]),
            _: 1
          }, 8, ["model", "onSubmit"])
        ]),
        _: 1
      }),
      _createVNode(_component_PageContentSection, { "always-expanded": true }, {
        header: _withCtx(() => [
          _createTextVNode("Cài đặt hệ thống")
        ]),
        actions: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_el_select, {
              modelValue: _ctx.caiDatFilter,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.caiDatFilter) = $event)),
              size: "small",
              style: {"width":"160px"},
              placeholder: "Lọc"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_option, {
                  label: "Tất cả",
                  value: "all"
                }),
                _createVNode(_component_el_option, {
                  label: "Có thể sửa",
                  value: "editable"
                }),
                _createVNode(_component_el_option, {
                  label: "Chỉ đọc (Kho)",
                  value: "readonly"
                })
              ]),
              _: 1
            }, 8, ["modelValue"]),
            (_ctx.isSuperadmin)
              ? (_openBlock(), _createBlock(_component_el_checkbox, {
                  key: 0,
                  modelValue: _ctx.showAllDonVi,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.showAllDonVi) = $event)),
                  size: "small",
                  onChange: _ctx.fetchCaiDat
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Tất cả đơn vị ")
                  ]),
                  _: 1
                }, 8, ["modelValue", "onChange"]))
              : _createCommentVNode("", true),
            (_ctx.isSuperadmin)
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 1,
                  type: "primary",
                  size: "small",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.createDialogVisible = true))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Thêm khóa ")
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ])
        ]),
        default: _withCtx(() => [
          _withDirectives((_openBlock(), _createBlock(_component_el_table, {
            border: true,
            "empty-text": "Chưa có cài đặt",
            data: _ctx.filteredCaiDatItems,
            style: {"width":"100%"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                label: "STT",
                width: "70",
                align: "center"
              }, {
                default: _withCtx((scope) => [
                  _createTextVNode(_toDisplayString(scope.$index + 1), 1)
                ]),
                _: 1
              }),
              (_ctx.showAllDonVi)
                ? (_openBlock(), _createBlock(_component_el_table_column, {
                    key: 0,
                    label: "Đơn vị",
                    prop: "id_don_vi",
                    width: "100",
                    align: "center"
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_el_table_column, {
                label: "Khóa",
                prop: "khoa",
                "min-width": "200"
              }),
              _createVNode(_component_el_table_column, {
                label: "Kiểu",
                width: "110",
                align: "center"
              }, {
                default: _withCtx((scope) => [
                  _createTextVNode(_toDisplayString(_ctx.loaiGiaTriLabel(scope.row.loai_gia_tri)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                label: "Giá trị",
                prop: "gia_tri",
                "min-width": "160"
              }, {
                default: _withCtx((scope) => [
                  _createTextVNode(_toDisplayString(_ctx.formatGiaTriDisplay(scope.row)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                label: "Ghi chú",
                prop: "ghi_chu",
                "min-width": "160"
              }, {
                default: _withCtx((scope) => [
                  _createTextVNode(_toDisplayString(scope.row.ghi_chu ?? '-'), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                label: "Trạng thái",
                width: "120",
                align: "center"
              }, {
                default: _withCtx((scope) => [
                  (scope.row.is_readonly)
                    ? (_openBlock(), _createBlock(_component_el_tag, {
                        key: 0,
                        type: "info",
                        size: "small",
                        "disable-transitions": ""
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Chỉ đọc ")
                        ]),
                        _: 1
                      }))
                    : (_openBlock(), _createBlock(_component_el_tag, {
                        key: 1,
                        type: "success",
                        size: "small",
                        "disable-transitions": ""
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Có thể sửa ")
                        ]),
                        _: 1
                      }))
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                label: "ID kho",
                width: "90",
                align: "center"
              }, {
                default: _withCtx((scope) => [
                  _createTextVNode(_toDisplayString(scope.row.id_kho ?? '-'), 1)
                ]),
                _: 1
              }),
              (_ctx.canEditCaiDat)
                ? (_openBlock(), _createBlock(_component_el_table_column, {
                    key: 1,
                    label: "Thao tác",
                    width: "100",
                    align: "center",
                    fixed: "right"
                  }, {
                    default: _withCtx((scope) => [
                      (!scope.row.is_readonly)
                        ? (_openBlock(), _createBlock(_component_el_button, {
                            key: 0,
                            type: "primary",
                            link: "",
                            size: "small",
                            onClick: ($event: any) => (_ctx.openEditDialog(scope.row))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Sửa ")
                            ]),
                            _: 2
                          }, 1032, ["onClick"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["data"])), [
            [_directive_loading, _ctx.caiDatLoading]
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_CaiDatCreateModal, {
        "is-open": _ctx.createDialogVisible,
        onClose: _cache[5] || (_cache[5] = ($event: any) => (_ctx.createDialogVisible = false)),
        onSuccess: _ctx.fetchCaiDat
      }, null, 8, ["is-open", "onSuccess"]),
      _createVNode(_component_CaiDatEditModal, {
        "is-open": _ctx.editDialogVisible,
        item: _ctx.editingItem,
        onClose: _ctx.closeEditDialog,
        onSuccess: _ctx.fetchCaiDat
      }, null, 8, ["is-open", "item", "onClose", "onSuccess"])
    ]),
    _: 1
  }))
}